import * as React from 'react';

const ReviewStar = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width={14} height={14} fill="none" viewBox="0 0 14 14" {...props}>
        <path
            fill="#002395"
            d="M6.483 11.928a1 1 0 0 1 1.034 0l2.398 1.448c.757.457 1.692-.222 1.49-1.084l-.636-2.728a1 1 0 0 1 .32-.983l2.12-1.837c.668-.579.31-1.677-.57-1.752l-2.79-.237a1 1 0 0 1-.836-.606L7.92 1.573c-.345-.813-1.497-.813-1.842 0L4.987 4.149a1 1 0 0 1-.836.606l-2.79.237c-.88.075-1.238 1.173-.57 1.752l2.12 1.837a1 1 0 0 1 .32.983l-.637 2.728c-.2.862.734 1.54 1.491 1.084z"
        />
    </svg>
);
export default ReviewStar;
